import React, { useEffect, useState } from 'react';
import { FaLongArrowAltLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/apiService';

const ViewActualBulkUploadHistory = () => {
  const [history,setHistory] = useState([]);

   const navigate = useNavigate();
   const [total, setTotal] = useState(0); // Store total number of records for pagination
    const [currentPage, setCurrentPage] = useState(1); // Store current page for pagination     
    const [pageSize, setPageSize] = useState(10); // Store page size for pagination
  const getActualSalesUploadHistory = async (page,limit) => { 
    try {
      const payload = {
        page,
        limit,
    };
      const response = await apiService('actual-sales/actualsalesuploadhistory', 'POST', payload); // Adjust the payload as needed

      setHistory(response.data.records); // Assuming the response contains the records
    } catch (error) {   

      console.error('Error fetching upload history:', error); 

    }
  };
  useEffect(() => { 

    getActualSalesUploadHistory(currentPage, pageSize)
  }, [currentPage, pageSize]);

  return (
    <div className=" bg-white p-4 ">
      <button className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 cursor-pointer" onClick={() => navigate("/upload-actual-excel")}>
        <span className='text-white flex flex-row'>  <FaLongArrowAltLeft /> &nbsp; Back</span>
      </button>
      <div className="container mx-auto">
        <div className="flex justify-between items-center border-b p-4">
          <h1 className="text-xl font-semibold">Bulk Upload History</h1>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-gray-600">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 text-left">Transaction ID</th>
                <th className="px-4 py-2 text-left">File Name</th>
                <th className="px-4 py-2 text-left">Success Count</th>
                <th className="px-4 py-2 text-left">Failure Count</th>


                <th className="px-4 py-2 text-left">Created at</th>
                <th className="px-4 py-2 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {history.map((entry, index) => (
                <tr key={index} className={`border-b `}>
                  <td className="px-4 py-2">{entry.upload_id}</td>
                  <td className="px-4 py-2">{entry.file_name}</td>
                  <td className="px-4 text-center py-2 text-green-700" >{entry.success_count}</td>
                  <td className="px-4  text-center  py-2 text-red-700">{entry.failure_count}</td>
                  <td className="px-4 py-2">{entry.created_at}</td>
                  <td className="px-4 py-2  flex gap-3">
                    <button onClick={() => navigate(`/bulk-upload-history-details/${entry.upload_id}`)}
                      className={`${entry.status === 'ERRORED' ? 'bg-orange-500' : 'bg-green-500'
                        } text-white py-1 px-3 rounded-md hover:bg-opacity-80 mr-2 cursor-pointer`}
                    >
                        <span className='text-white'>View Details</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ViewActualBulkUploadHistory;
